(() => {
  const formatChileInteger = (value) => {
    const digits = String(Math.max(0, Math.round(Number(value) || 0)));
    return digits.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  };

  const formatPeso = (value) => `$${formatChileInteger(value)}`;

  const normalizeChileMoney = (text) => String(text || '').replace(/\$\s*\d[\d.,]*/g, (money) => {
    const digits = money.replace(/[^\d]/g, '');
    if (!digits) return money;
    return `$${digits.replace(/\B(?=(\d{3})+(?!\d))/g, '.')}`;
  });

  const cleanTextNode = (node) => {
    if (!node || node.nodeType !== Node.TEXT_NODE) return;
    const parent = node.parentElement;
    if (parent && ['SCRIPT', 'STYLE', 'TEXTAREA'].includes(parent.tagName)) return;

    const original = node.nodeValue || '';
    let next = original
      .replace(/\s*CLP\b/gi, '')
      .replace(/\s{2,}/g, ' ');

    next = normalizeChileMoney(next);

    if (next !== original) node.nodeValue = next;
  };

  const cleanRoot = (root) => {
    if (!root) return;
    if (root.nodeType === Node.TEXT_NODE) {
      cleanTextNode(root);
      return;
    }

    if (root.nodeType !== Node.ELEMENT_NODE && root.nodeType !== Node.DOCUMENT_NODE && root.nodeType !== Node.DOCUMENT_FRAGMENT_NODE) {
      return;
    }

    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    let node;
    while ((node = walker.nextNode())) cleanTextNode(node);
  };

  const rewriteSaleBadges = (root) => {
    const searchRoot = root && root.querySelectorAll ? root : document;
    searchRoot.querySelectorAll('.card__badge .badge').forEach((badge) => {
      if (!/\b(oferta|sale)\b/i.test((badge.textContent || '').trim())) return;

      const card = badge.closest('.card-wrapper, .card');
      if (!card) return;

      const priceEl = card.querySelector('.price-item--sale, .price__regular .price-item--regular');
      const compareEl = card.querySelector('.price__sale s.price-item--regular, s.price-item--regular');
      const priceText = priceEl ? priceEl.textContent : '';
      const compareText = compareEl ? compareEl.textContent : '';
      const parseMoney = (text) => Number(String(text || '').replace(/[^\d]/g, ''));

      const price = parseMoney(priceText);
      const compare = parseMoney(compareText);
      if (!(compare > price && price > 0)) return;

      badge.textContent = `AHORRA ${formatPeso(compare - price)}`;
    });
  };

  const run = (root = document) => {
    cleanRoot(root);
    rewriteSaleBadges(root);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => run());
  } else {
    run();
  }

  let scheduled = false;
  const observer = new MutationObserver((mutations) => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => run(node));
        if (mutation.type === 'characterData') cleanTextNode(mutation.target);
      });
      rewriteSaleBadges(document);
    });
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
    characterData: true
  });
})();
